import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { virtualCueRewards } from '../../constants/images'

const BackgroundSection = ({ progress, phases, assets }) => {
	return (
		<CSSTransitionGroup
			className="fade"
			transitionName="fade"
			transitionEnterTimeout={800}
			transitionLeaveTimeout={800}>
			{progress > 27500 && <img key={'phase1'} src={phases[0]}/>}
			{progress > 40000 && <img key={'phase2'} src={phases[1]}/>}
			{progress > 50000 && <img key={'phase3'} src={phases[2]}/>}
			{progress > 60000 && <img key={'phase4'} src={phases[3]}/>}
			{progress > 80000 && <img key={'phase5'} src={phases[4]}/>}
			{assets && assets.map((asset) => <img key={asset} className={asset} src={virtualCueRewards[asset]}/>)}
		</CSSTransitionGroup>
	)
}

export { BackgroundSection }